import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TaxAdvisorLayout } from "../menu/TaxAdvisorLayout";
import type { RouterContext } from "../RouterContext";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <TaxAdvisorLayout>
      <Outlet />
    </TaxAdvisorLayout>
  );
}
